import _ from 'lodash';
import hash from 'object-hash';
import md5 from 'md5';
import React from 'react';
import * as skyjsDate from '@skyjs/date';
import * as skyjsLang from '@skyjs/lang';
import * as skyjsLodashExtras from '@skyjs/lodash-extras';
import * as skyjsModel from '@skyjs/model';
import * as skyjsQuery from '@skyjs/query';
import * as skyjsCodegen from '@skyjs/codegen';
import Collection from '@skyjs/collection';
import filter from '@skyjs/filter';
import merge from '@skyjs/merge';
import diff from '@skyjs/diff';
import * as sucrase from 'sucrase';
import * as yaml from 'yaml';
import dompurify from 'dompurify';

export default {
  lodash: _,
  'object-hash': hash,
  md5,
  react: React,
  sucrase,
  yaml,
  dompurify,
  '@skyjs/date': skyjsDate,
  '@skyjs/lang': skyjsLang,
  '@skyjs/lodash-extras': skyjsLodashExtras,
  '@skyjs/model': skyjsModel,
  '@skyjs/query': skyjsQuery,
  '@skyjs/codegen': skyjsCodegen,
  '@skyjs/collection': Collection,
  '@skyjs/filter': filter,
  '@skyjs/merge': merge,
  '@skyjs/diff': diff
};
